import './components/throttle';
import './components/carousel';
import './components/steps';
import './components/result';
import './components/form';
import './components/country-gate';

import SmoothScrollMagic from './components/smoothScroll';
let smoothScrollAllPage = new SmoothScrollMagic;
smoothScrollAllPage.init();

const layout = document.querySelector('.layout');
const pageY = () => {
    return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
}

if(!layout.classList.contains('removeSmoothScroll')){
    window.addEventListener("optimizedScroll", function() {
        if (pageY() > 10) {
            document.body.classList.add("is-scrolled");
        } else {
            document.body.classList.remove("is-scrolled");
        }

        setTimeout(() => {
            headerHeight();
        }, 100);
    });
}

let isTouch = false;
if ('ontouchstart' in document.documentElement) {
    isTouch = true;
}
document.body.className += isTouch ? ' touch' : ' no-touch';

window.addEventListener("optimizedResize", function() {
    headerHeight();
});

// Modal menu
(function () {
    const triggerModals = document.querySelectorAll('[data-modal]');
    if (triggerModals.length) {
        triggerModals.forEach(e => {
            const id = e.dataset.modal;
            const modal = document.querySelector('#'+id);
            if(!!modal){
                const closeModal = modal.querySelectorAll('[aria-label="Close"]');

                closeModal.forEach(e => {
                    e.onclick = () => {
                        document.body.classList.remove('show-modal');
                        modal.classList.toggle('is-open');
                    };
                })

            }
        })
    }
})();

// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
let vh = window.innerHeight * 0.01;
// Then we set the value in the --vh custom property to the root of the document
document.documentElement.style.setProperty('--vh', `${vh}px`);

// We listen to the resize event
window.addEventListener('resize', () => {
    // We execute the same script as before
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
});

document.addEventListener("DOMContentLoaded", () => {
    const videoOverlay = document.querySelector(".intro__video_overlay");
    const iframe = document.querySelector(".intro__video iframe");

    if (videoOverlay && iframe) {
        videoOverlay.addEventListener("click", () => {
            const videoSrc = iframe.getAttribute("src");

            if (videoSrc) {
                const updatedSrc = videoSrc.includes("autoplay=1") ?
                    videoSrc :
                    `${videoSrc}&autoplay=1`;

                iframe.setAttribute("src", updatedSrc);
                videoOverlay.style.display = "none";
            } else {
                console.error("Iframe src attribute is empty or invalid.");
            }
        });
    } else {
        console.error("Video overlay or iframe element is not found.");
    }
});
